import Enum from '/@/modules/core/app/helpers/Enum';

export class MetricName extends Enum {
  static FILE_ADDED = { key: 'file_added', triggerValue: 5 };

  static ASSET_ADDED = { key: 'asset_added', triggerValue: 5 };

  static LIABILITY_ADDED = { key: 'liability_added', triggerValue: 5 };

  static MESSAGE_SENT = { key: 'message_sent', triggerValue: 5 };

  static CONVERSATION_CREATED = { key: 'conversation_created', triggerValue: 3 };

  static OVERVIEW_PAGE_VIEWED = { key: 'overview_page_viewed', triggerValue: 5 };
}
